import { savePartialProfile } from 'Features/MemberProfile/memberProfileSlice';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components/macro';
import type { History } from 'history';
import { useHistory } from 'react-router-dom';
import { checkActiveSession, updateUser } from 'Features/Auth/authSlice';
import {
  Phase0,
  Phase1,
  Phase2,
  Phase3,
  Phase4,
  Phase5,
} from './FieldComponents';

const FormFieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0 7px 7px -10px rgba(0, 0, 0, 0.41);
  label {
    color: #222;
    font-family: acumin-pro;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 19px;
    margin-bottom: 10px;
    span {
      color: #D73714;
    }
    &.top-margin {
      margin-top: 10px;
    }
  }
  input.form-select,
  textarea.form-select {
    border: 1px solid #d6dce2;
    border-radius: 3px;
    padding: 15px;
    margin-bottom: 30px;
    outline: none;
    &:last-of-type {
      margin-bottom: 10px;
    }
    &.borderless {
      width: calc(100% - 20px);
      max-width: none;
      border-left: none;
      border-right: none;
      border-top: none;
      margin-bottom: 0;
      padding: 15px 10px 15px 0;
    }
  }
  .search {
    display: flex;
    align-items: center;
    gap: 16px;
    user-select: none;
    .add-skill {
      white-space: nowrap;
      margin-left: 20px;
      display: flex;
      align-items: center;
      cursor: pointer;
      span {
        margin-right: 10px;
        color: #252525;
        font-family: acumin-pro;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 17px;
      }
      svg {
        color: #0a4ea2;
        font-size: 20px;
        font-weight: 300;
        letter-spacing: 0;
      }
    }
  }
  .search-bar {
    flex-grow: 1;
    margin-right: 10px;
    position: relative;
    svg {
      position: absolute;
      width: 15px;
      height: 15px;
      top: calc(50% - 7.5px);
      right: 0;
    }
  }
`;

const FormFields = ({
  currentTab,
  values,
  setValue,
  nextForm,
  createProfile,
  validationErrors,
}: {
  currentTab: number;
  values: { [key: string]: any };
  setValue: Function;
  nextForm: () => void;
  createProfile: () => void;
  validationErrors: Record<string, boolean>;
}) => {
  const dispatch = useDispatch();
  const history: History = useHistory();
  const { user } = useSelector((state: any) => state.auth);
  const renderFields = () => {
    const savePartial = async () => {
      await dispatch(savePartialProfile(values));
      if (user?.id) {
        await dispatch(
          updateUser({
            id: user.id,
            first_name: values.firstName,
            last_name: values.lastName,
            phone: values.phone,
            email: values.email,
          }),
        );
      }
      await dispatch(checkActiveSession());
      history.push('/jobs');
    };
    switch (currentTab) {
      case 0:
        return (
          <Phase0
            values={values}
            nextForm={nextForm}
            setValue={setValue}
            savePartial={savePartial}
          />
        );
      case 1:
        return (
          <Phase1
            values={values}
            nextForm={nextForm}
            setValue={setValue}
            savePartial={savePartial}
            validationErrors={validationErrors}
          />
        );
      case 2:
        return (
          <Phase2
            values={values}
            nextForm={nextForm}
            setValue={setValue}
            savePartial={savePartial}
            validationErrors={validationErrors}
          />
        );
      case 3:
        return (
          <Phase3
            values={values}
            nextForm={nextForm}
            setValue={setValue}
            savePartial={savePartial}
            validationErrors={validationErrors}
          />
        );
      case 4:
        return (
          <Phase4
            values={values}
            nextForm={nextForm}
            setValue={setValue}
            savePartial={savePartial}
            validationErrors={validationErrors}
          />
        );
      case 5:
        return (
          <Phase5
            values={values}
            setValue={setValue}
            createProfile={createProfile}
            savePartial={savePartial}
            validationErrors={validationErrors}
          />
        );
      default:
        return (
          <Phase0
            values={values}
            nextForm={nextForm}
            setValue={setValue}
            savePartial={savePartial}
          />
        );
    }
  };
  return <FormFieldsContainer>{renderFields()}</FormFieldsContainer>;
};

export default FormFields;
